import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AddupdatesolarmanagerComponent } from './addupdatesolarmanager/addupdatesolarmanager.component';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SolardashboardService } from 'src/app/services/solardashboard.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-solar-manager',
  templateUrl: './solar-manager.component.html',
  styleUrls: ['./solar-manager.component.scss']
})
export class SolarManagerComponent implements OnInit {
  deviceMaster:any =[]
   displayedColumns: string[] = ['serialnumber','sitename', 'deviceId', 'actions'];
    dataSource;
    roleID = JSON.parse(localStorage.getItem('userData')).roleid;
  
    @ViewChild(MatPaginator, {static:true}) paginator: MatPaginator;
    @ViewChild(MatSort,  {static:true}) sort: MatSort;
  constructor( private matDialog: MatDialog,private transformerMangSer:TransformerManagerService,private ngxLoader: NgxUiLoaderService,private solarService:SolardashboardService) { }

  ngOnInit() {   

    this.getSolarManagerData();

    this.transformerMangSer.getDeviceDdl().toPromise().then((response: any) => {
      this.deviceMaster = response.data;
    });
  }
  openDialog(action: any, data?: any){
      let dialogRef;
      if(action.toLowerCase()=='add'){
        dialogRef = this.matDialog.open(AddupdatesolarmanagerComponent, {
          height:'90%',
          width:'50%',
          data: {'deviceMaster':this.deviceMaster, 'action': 'add'}
        });
      } else if(action.toLowerCase() == 'update'){
        dialogRef = this.matDialog.open(AddupdatesolarmanagerComponent, {
          height:'90%',
          width:'50%',
          data: {'data': data,'deviceMaster': this.deviceMaster, 'action': 'update'}
        });
      }
      dialogRef.afterClosed().subscribe(result => {
        if (result.update) {
         this.getSolarManagerData();
        }
      });
    }
  doFilter(value){
    
  }

  ngAfterViewInit() {
      this.dataSource.paginator = this.paginator
  }
  
  getSolarManagerData() {
    console.log("asdasdasdads");
      this.ngxLoader.start();
      this.solarService.getSolarMagaer(JSON.parse(localStorage.getItem('userData')).roleid,JSON.parse(localStorage.getItem('userData')).userid,'solarManager').subscribe((response:any) => {
        if(response.status)
        {
          this.ngxLoader.stop();
          console.log(response);
          this.dataSource =  new MatTableDataSource(response.data);;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
        else{
          this.ngxLoader.stop();
        }
  
      })
  
    }

deletSolarManager(data) {
  Swal.fire({
    title: 'Are you sure?',
    text: 'Do you really want to delete this solar manager?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      this.solarService.deletSolarManager(data).subscribe(res => {
        if (res.status) {
          Swal.fire({
            title: "Success!",
            text: res.message,
            icon: "success",
            timer: 1000, 
            showConfirmButton: false
          });
          // Optionally refresh list or UI here
          this.getSolarManagerData();
        } else {
          Swal.fire('Error!', res.message || 'Deletion failed.', 'error');
        }
      }, err => {
        Swal.fire('Error!', 'Something went wrong while deleting.', 'error');
      });
    }
  });
}

}
